import * as THREE from "three";
import { SETTINGS } from "../SETTINGS";

export const createSunLight = () => {
  const sunLight = new THREE.DirectionalLight(SETTINGS.sunLight.color, SETTINGS.sunLight.intensity);
  sunLight.position.set(
    SETTINGS.sunLight.position.x,
    SETTINGS.sunLight.position.y,
    SETTINGS.sunLight.position.z
  );

  return sunLight;
};

export const createAmbientLight = () => {
  const ambientLight = new THREE.AmbientLight(
    SETTINGS.ambientLight.color,
    SETTINGS.ambientLight.intensity
  );

  return ambientLight;
};
